import React, { useState } from "react";
import { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { CheckToken } from "../../login/AccessToken";
import { ChangeCursor } from "../../hlthtek-demo/components/MiscFunctions";
import axios from "axios";
import { Select } from "antd";
import Navbar from "./Navbar";
import { toast } from "react-toastify";
import Autocomplete from "@mui/material/Autocomplete";
import {
  StyledSelect,
  StyledTextFieldBootstrap,
  StyledTooltip,
} from "../../doctor-console/StyledComponents";
import {
  TextField,
  Tooltip,
  Typography,
  Box,
  List,
  ListItem,
} from "@mui/material";
import { MenuItem, FormControl, InputLabel } from "@mui/material";
import { Grid, Button } from "@mui/material";
import RoleModalComponent from "../../hlthtek-demo/components/PopupFormodal";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

import Icon from "../../doctor-console/Utils/Icons";
// import { Button } from "jodit/types/modules";
// import { color } from "jodit/types/plugins/color/color";
// import { boxShadow } from "html2canvas/dist/types/css/property-descriptors/box-shadow";

function FacilityUsers({ updateList }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    getValues,
    control,
    reset,
  } = useForm();

  // const [userType, setUserType] = useState(["Choose User Type", "Admin", "User", "Partner", "Customer",
  //     "Facility Admin", "Facility User"])
  const [userType, setUserType] = useState([]);

  const [facilityList, setFacilityList] = useState([]);
  const [partnerList, setPartnerList] = useState([]);
  const [facilityListForCustomer, setFacilityListForCustomer] = useState([]);
  const [openRoleModal, setOpenRoleModal] = useState(false);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const [accessToken, setAccessToken] = useState("");
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  // const [selectedUserTypes, setSelectedUserTypes] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [customerListForPartner, setCustomerListForPartner] = useState([]);
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const history = useHistory();
  const roleType = sessionStorage.getItem("roleType");
  const facilityName = sessionStorage.getItem("facility_name");
  const [currentUserType, setCurrentUserType] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);
  const [roles, setRoles] = useState([]);
  console.log("roles", roles);
  useEffect(() => {
    const accessToken = sessionStorage.getItem("accessToken");
    const roleType = sessionStorage.getItem("roleType");

    if (
      !accessToken
      //||
      // (roleType !== "admin" &&
      //   roleType !== "facility admin" &&
      //   roleType !== "customer admin" &&
      //   roleType !== "partner admin" &&
      //   roleType !== "facility admin")
    ) {
      history.push("/login");
    }
  }, []);

  useEffect(() => {
    const roleType = sessionStorage.getItem("roleType");
    const subscriptionType = sessionStorage.getItem("subscriptionType");

    // if (roleType === "facility admin") {
    //   setUserType(["Facility User", "Lab User", "Pharmacy User"]);
    // }
    if (roleType === "facility admin") {
      if (
        subscriptionType === "EHR/HMIS Service With ABDM Connector - HIU/HIP" ||
        subscriptionType === "EHR/HMIS Service Without ABDM Connector"
      ) {
        setUserType(["Facility User", "Lab User", "Pharmacy User"]);
      } else {
        setUserType(["Facility User"]);
      }
    } else if (roleType === "customer admin") {
      setUserType(["Facility User", "Facility Admin"]);
      // } else if (roleType === "partner admin") {
      //   setUserType(["Customer Admin"]);
    } else {
      setUserType([
        // "Partner Admin",
        // "Customer Admin",
        "Facility Admin",
        "Facility User",
        "Lab User",
        "Pharmacy User",
      ]);
    }
  }, []);
  // console.log("userType",currentUserType)
  // useEffect(() => {
  //   axios
  //     .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_partners_list/`, {
  //       headers: headers,
  //     })
  //     .then((res) => {
  //       console.log(res.data);
  //       setPartnerList(res.data.partner_list);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       toast.error(err);
  //     });
  // }, []);

  // useEffect(() => {
  //   // const post_data = {
  //   //     role_type: roleType,
  //   // };
  //   if (roleType === "admin" && Token()) {
  //     axios
  //       .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_clients/`, {
  //         headers: headers,
  //       })
  //       .then((res) => {
  //         console.log(" client data", res.data);
  //         console.log("In client func", res.data.client_list);
  //         setCustomerList(res.data.client_list);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //         toast.error(err);
  //       });
  //   }
  // }, []);

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  useEffect(() => {
    fetchAllRoles();
  }, []);
  useEffect(() => {
    const roleType = sessionStorage.getItem("roleType");
    // console.log("init");
    const partnerId = sessionStorage.getItem("partner_id");
    const customer_name = sessionStorage.getItem("customer_name");
    const post_data = {
      role_type: roleType,
      partner_id: partnerId,
      customer_name: customer_name,
    };
    console.log("post_data", post_data);
    console.log("currentUserType", currentUserType);
    if (
      roleType === "admin" &&
      // || roleType === "facility admin"
      Token()
    ) {
      if (
        currentUserType === "lab user" ||
        currentUserType === "pharmacy user"
      ) {
        axios
          .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_facilities/`, {
            headers: headers,
          })
          .then((res) => {
            if (res.data.status === "Success") {
              // Filter facilities with the specific subscription types
              const filteredFacilities = res.data.facility_list.filter(
                (facility) =>
                  facility.subscription_type ===
                    "EHR/HMIS Service With ABDM Connector - HIU/HIP" ||
                  facility.subscription_type ===
                    "EHR/HMIS Service Without ABDM Connector"
              );
              setFacilityList(filteredFacilities);
              console.log("Filtered facility list", filteredFacilities);
            } else {
              console.log("facility list test", res.data.message);
            }
          })
          .catch((err) => {
            console.log(err);
            toast.error(err);
          });
      } else {
        // If another user type is selected, fetch all facilities
        axios
          .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_facilities/`, {
            headers: headers,
          })
          .then((res) => {
            if (res.data.status === "Success") {
              setFacilityList(res.data.facility_list);
              console.log("Complete facility list", res.data.facility_list);
            } else {
              console.log("facility list test", res.data.message);
            }
          })
          .catch((err) => {
            console.log(err);
            toast.error(err);
          });
      }
    } else if (roleType === "partner admin" && Token()) {
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}get_all_clients_from_partner/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.data.status === "Success") {
            setCustomerListForPartner(res.data.client_list);
            console.log("client list test", res.data);
          } else {
            console.log("partner_Admin", res.data.message);
            //ChangeCursor();
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    } else if (roleType === "customer admin" && Token()) {
      console.log("in customer....");
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}get_all_facilities_from_client/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.data.status === "Success") {
            setFacilityListForCustomer(res.data.facility_list);
            console.log("facility list test", res.data);
          } else {
            console.log("customer_Admin", res.data.message);
            //ChangeCursor();
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    }
  }, [authToken, currentUserType]);

  const handleUserTypeChange = (selectedUserType) => {
    if (!selectedUserType) {
      setCurrentUserType("");
      return;
    }
    console.log("userType..", selectedUserType);
    const lowerCaseUserType = selectedUserType.toLowerCase();
    setCurrentUserType(lowerCaseUserType);
  };
  console.log("ff", currentUserType);

  const onSubmit = (data, e) => {
    // console.log(getValues("user_type"))
    // if (getValues("user_type") === userType[0]) {
    //     setError("user_type", { type: 'validate', message: "User Type is required" }, { shouldFocus: true })
    //     return;
    // }
    // if (!getValues("user_type")) {
    //   setError(
    //     "user_type",
    //     { type: "validate", message: "User Type is required" },
    //     { shouldFocus: true }
    //   );
    //   return;
    // }
    // let facilityId = null;

    // if (roleType === 'facility admin') {
    //     const selectedFacility = facilityList.find(item => item.facility_name === data.facility);
    //     facilityId = selectedFacility ? selectedFacility.facility_id : null;
    // }

    e.preventDefault();
    console.log(data);
    if (Token()) {
      ChangeCursor();
      var post_data = {};
      post_data.email = data.email;
      post_data.username = data.username;
      post_data.password = data.password;
      post_data.first_name = data.first_name;
      post_data.last_name = data.last_name;
      post_data.dob = data.dob;
      post_data.address = data.address;
      post_data.user_type = data.user_type;
      // post_data.user_type= selectedUserTypes
      // post_data.facility = data.facility
      post_data.active = data.active === "on";
      post_data.partner = data.partner;
      post_data.customer = data.customer;
      post_data.salutation = data.salutation;
      post_data.role = data.role_type;

      if (roleType === "facility admin") {
        post_data.facility = sessionStorage.getItem("facility_name");
      } else {
        post_data.facility = data.facility;
      }
      console.log("Data ", post_data);

      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}add_new_user/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.data.status === "Success") {
            toast.success("User Added !!");
            console.log(res);
            updateList();
            //ChangeCursor();
          } else {
            if (res.data.message.includes("limit")) {
              reset();
            }
            toast.error(res.data.message);
            console.log("checcking..", res.data.message);
            //ChangeCursor();
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    }
  };
  const fetchAllRoles = () =>
    axios
      .get(`${REACT_APP_BACKEND_ROUTE_URL}roles/`, { headers })
      .then(({ data }) => setRoles(data?.data ?? []))
      .catch((err) => console.error("fetchAllRoles:", err));
  return (
    <div>
      {/* <Navbar /> */}

      <RoleModalComponent
        open={openRoleModal}
        onClose={() => setOpenRoleModal(false)}
      />

      <div className="col-sm-12 col-md-12 col-lg-10" style={{ margin: "auto" }}>
        <div className="contact-panel mb-50" style={{ marginTop: "50px" }}>
          <h4 style={{ textAlign: "center" }}>Add New User</h4>
          <form
            className="contact-panel__form"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  {/* <i className="icon-news form-group-icon"></i> */}
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter User ID"
                    name="user_id"
                    disabled
                    value={""}
                    {...register("user_id")}
                    hidden
                  />
                </div>
              </div>
              <div className="col-12">
                <label htmlFor="email" className="required-label">
                  Email{" "}
                </label>
                <div className="form-group">
                  {/* <i className="icon-news form-group-icon"></i> */}
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Email"
                    name="email"
                    {...register("email", {
                      required: "Email is required.",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Invalid email address",
                      },
                    })}
                  />
                  {errors.email && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.email.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-12">
                <label htmlFor="username" className="required-label">
                  User Name{" "}
                </label>
                <div className="form-group">
                  {/* <i className="icon-news form-group-icon"></i> */}
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter User Name"
                    name="username"
                    {...register("username", {
                      required: "User Name is required.",
                    })}
                    autoComplete="new-username" // Use a unique value to prevent autofill
                  />
                  {errors.username && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.username.message}
                    </p>
                  )}
                </div>
              </div>
              {/* <div className="col-12">
                <label htmlFor="password" className="required-label">
                  Password{" "}
                </label>
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Enter Password"
                    name="password"
                    {...register("password", {
                      required: "Password is required.",
                    })}
                    autoComplete="off"
                  />
                  {errors.password && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.password.message}
                    </p>
                  )}
                </div>
              </div> */}
              <div className="col-12">
                <label htmlFor="password" className="required-label">
                  Password{" "}
                </label>
                <div className="form-group">
                  {/* <i className="icon-news form-group-icon"></i> */}

                  <StyledTooltip
                    open={showTooltip}
                    title={
                      <Box
                        sx={{
                          backgroundColor: "#21cdc0", // Use a specific color code for better control
                          p: 2, // Add padding inside the box for better spacing
                          borderRadius: "8px", // Rounded corners for smooth look
                          boxShadow: "0px 0px 0px white", // Optional: subtle shadow effect
                          border: "none",
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          sx={{ fontWeight: "bold", color: "#fff" }}
                        >
                          Password requirements
                        </Typography>
                        <List sx={{ color: "#fff" }}>
                          <ListItem>An alphabet</ListItem>
                          <ListItem>A number</ListItem>
                          <ListItem>A special character</ListItem>
                          <ListItem>Minimum 8 characters</ListItem>
                        </List>
                      </Box>
                    }
                    arrow
                    placement="bottom-end"
                  >
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Enter Password"
                      name="password"
                      {...register("password", {
                        required: "Password is required.",
                      })}
                      autoComplete="off"
                      onFocus={() => setShowTooltip(true)} // Show tooltip on focus
                      onBlur={() => setShowTooltip(false)} // Hide tooltip on blur
                    />
                  </StyledTooltip>

                  {errors.password && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.password.message}
                    </p>
                  )}
                </div>
              </div>

              {/* <div className="col-12 d-flex" style={{ padding: "0px" }}> */}
              <div className="col-sm-6 col-md-6 col-lg-6 ">
                <label htmlFor="salutation" className="required-label">
                  Salutation
                </label>
                <div className="form-group">
                  {/* <i className="icon-user form-group-icon"></i> */}
                  <select
                    className="form-control"
                    name="salutation"
                    {...register("salutation", {})}
                  >
                    <option value="">Select Salutation</option>
                    {[
                      "Mr",
                      "Mrs",
                      "Ms",
                      "Miss",
                      "Dr",
                      "Prof",
                      "Master",
                      "Rev",
                      "Mx",
                    ].map((title) => (
                      <option key={title} value={title}>
                        {title}
                      </option>
                    ))}
                  </select>
                  {errors.salutation && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.salutation.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="first_name" className="required-label">
                  First Name{" "}
                </label>
                <div className="form-group">
                  {/* <i className="icon-news form-group-icon"></i> */}
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter First Name"
                    name="first_name"
                    {...register("first_name", {
                      required: "First Name is required.",
                    })}
                  />
                  {errors.first_name && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.first_name.message}
                    </p>
                  )}
                </div>
              </div>
              {/* </div> */}
              {/* <div className="col-12 d-flex" style={{ padding: "0px" }}> */}
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="last_name" className="required-label">
                  Last Name{" "}
                </label>
                <div className="form-group">
                  {/* <i className="icon-news form-group-icon"></i> */}
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Last Name"
                    name="last_name"
                    {...register("last_name", {
                      required: "Last Name is required.",
                    })}
                  />
                  {errors.last_name && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.last_name.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="dob" className="required-label">
                  DOB{" "}
                </label>

                <div className="form-group form-group-date">
                  <i className="icon-calendar form-group-icon"></i>
                  <input
                    type="date"
                    className="form-control"
                    placeholder="Enter DOB"
                    name="dob"
                    {...register("dob", {
                      required: "DOB is required.",
                    })}
                  />
                  {errors.dob && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.dob.message}
                    </p>
                  )}
                </div>
              </div>
              {/* </div> */}
              {/* <div className="col-12 d-flex" style={{ padding: "0px" }}> */}
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="address" className="required-label">
                  Address{" "}
                </label>
                <div className="form-group">
                  {/* <i className="icon-news form-group-icon"></i> */}
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Address"
                    name="address"
                    {...register("address", {
                      required: "Address is required.",
                    })}
                  />
                  {errors.address && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.address.message}
                    </p>
                  )}
                </div>
              </div>

              {/* <div className="col-sm-6 col-md-6 col-lg-6">
                                <label htmlFor="user_type" className="required-label">User Type </label>
                                <div className="form-group">
                                    <Controller
                                        name="user_type"
                                        control={control}
                                        className='form-control'
                                        render={({ field }) => (
                                            <Select
                                            className='form-control'
                                                placeholder="Select User"
                                              
                                               
                                                onChange={(selectedValues) => {
                                                    field.onChange(selectedValues);
                                                    handleUserTypeChange(selectedValues);
                                                }}
                                                value={field.value}
                                            >
                                                {userType.map((item, index) => (
                                                    <Select.Option value={item}>{item}</Select.Option>
                                                ))}


                                            </Select>
                                        )}
                                    />
                                    {errors.user_type && (
                                        <p className="errorMsg" style={{ color: "red" }}>{errors.user_type.message}</p>
                                    )}
                                </div>
                            </div> */}

              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="user_type" className="required-label">
                  User Type{" "}
                </label>
                <div className="form-group">
                  <FormControl fullWidth error={!!errors.user_type}>
                    <Controller
                      name="user_type"
                      control={control}
                      rules={{ required: "User Type is required." }} // Add validation if needed
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          options={userType}
                          getOptionLabel={(option) => option} // Assuming userType is an array of strings
                          renderInput={(params) => (
                            <StyledTextFieldBootstrap
                              {...params}
                              placeholder="Select User Type"
                            />
                          )}
                          onChange={(_, value) => {
                            field.onChange(value);
                            handleUserTypeChange(value); // Call the function with the selected value
                          }}
                          value={field.value || null} // Handle the case where the value might be null
                        />
                      )}
                    />
                    {errors.user_type && (
                      <p className="errorMsg" style={{ color: "red" }}>
                        {errors.user_type.message}
                      </p>
                    )}
                  </FormControl>
                </div>
              </div>
              {/* </div> */}
              {/* <div className="col-12"> */}
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="role_type" className="required-label">
                  Role Type{" "}
                </label>
                <div className="form-group">
                  <FormControl fullWidth error={!!errors.role_type}>
                    <Controller
                      name="role_type"
                      control={control}
                      rules={{ required: "Role Type is required." }}
                      render={({ field }) => (
                        <Autocomplete
                          options={roles} // roles = array of objects
                          getOptionLabel={(option) => option?.name ?? ""} // show role name
                          isOptionEqualToValue={(option, value) =>
                            option.id === value?.id
                          }
                          renderInput={(params) => (
                            <StyledTextFieldBootstrap
                              {...params}
                              placeholder="Select Role Type"
                            />
                          )}
                          value={
                            roles.find((r) => r.name === field.value) || null
                          }
                          onChange={(_, value) =>
                            field.onChange(value ? value.name : "")
                          }
                        />
                      )}
                    />
                    {errors.role_type && (
                      <p className="errorMsg" style={{ color: "red" }}>
                        {errors.role_type.message}
                      </p>
                    )}
                  </FormControl>
                </div>
              </div>
              <div
                className="col-sm-3 col-md-3 col-lg-3"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "3%",
                }}
              >
                <div className="form-group">
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      placeholder="Active"
                      name="active"
                      {...register("active")}
                    />
                    <label className="form-check-label" htmlFor="active">
                      Active
                    </label>
                  </div>
                  {errors.active && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.active.message}
                    </p>
                  )}
                </div>
              </div>
              {/* <div className="col-sm-3 col-md-3 col-lg-3" style={{ marginTop: '1.02%' }}>
                <button
                  type="submit"
                  className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10"
                >
                  <span>Add User</span> <i className="icon-arrow-right"></i>
                </button>
              </div> */}
              {/* </div> */}

              {roleType === "admin" ? (
                <>
                  {currentUserType === "partner admin" && (
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <label className="required-label">Partner List</label>
                      <div className="form-group">
                        <Controller
                          name="partner"
                          control={control}
                          rules={{ required: "Partner Name is required." }}
                          render={({ field }) => (
                            <Autocomplete
                              {...field}
                              options={partnerList}
                              getOptionLabel={(option) =>
                                option.company_name || ""
                              }
                              renderInput={(params) => (
                                <StyledTextFieldBootstrap
                                  {...params}
                                  placeholder="Select Partner"
                                />
                              )}
                              onChange={(_, value) => {
                                field.onChange(value ? value.partner_id : "");
                              }}
                            />
                          )}
                        />
                        {errors.partner && (
                          <p className="errorMsg" style={{ color: "red" }}>
                            {errors.partner.message}
                          </p>
                        )}
                      </div>
                    </div>
                  )}

                  {currentUserType === "customer admin" && (
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <label className="required-label">Customer List</label>
                      <div className="form-group">
                        <Controller
                          name="customer"
                          control={control}
                          rules={{ required: "Customer Name is required." }}
                          render={({ field }) => (
                            <Autocomplete
                              {...field}
                              options={customerList}
                              getOptionLabel={(option) =>
                                option.client_name || ""
                              }
                              renderInput={(params) => (
                                <StyledTextFieldBootstrap
                                  {...params}
                                  placeholder="Select Customer"
                                />
                              )}
                              onChange={(_, value) => {
                                field.onChange(value ? value.client_name : "");
                              }}
                            />
                          )}
                        />
                        {errors.customer && (
                          <p className="errorMsg" style={{ color: "red" }}>
                            {errors.customer.message}
                          </p>
                        )}
                      </div>
                    </div>
                  )}

                  {(currentUserType === "facility admin" ||
                    currentUserType === "facility user" ||
                    currentUserType === "lab user" ||
                    currentUserType === "pharmacy user") && (
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <label className="required-label">Facility List</label>
                      <div className="form-group">
                        <Controller
                          name="facility"
                          control={control}
                          rules={{ required: "Facility Name is required." }}
                          render={({ field }) => (
                            <Autocomplete
                              {...field}
                              options={facilityList}
                              getOptionLabel={(option) =>
                                option.facility_name || ""
                              }
                              renderInput={(params) => (
                                <StyledTextFieldBootstrap
                                  {...params}
                                  placeholder="Select Facility"
                                />
                              )}
                              onChange={(_, value) => {
                                field.onChange(value ? value.facility_id : "");
                              }}
                            />
                          )}
                        />
                        {errors.facility && (
                          <p className="errorMsg" style={{ color: "red" }}>
                            {errors.facility.message}
                          </p>
                        )}
                      </div>
                    </div>
                  )}
                </>
              ) : (
                // <div className="col-sm-6 col-md-6 col-lg-6">
                //     <label>{roleType === 'partner admin' ? 'Customer Name' : 'Facility Name'}</label>
                //     <div className="form-group">
                //         <i className="icon-user form-group-icon"></i>
                //         {roleType === 'partner admin' ?
                //             <select className="form-control" name='customer' {...register("customer")}>
                //                 {customerListForPartner && customerListForPartner.length > 0 ?
                //                     customerListForPartner.map((item, index) => (
                //                         <option key={index} value={item.client_name}>{item.client_name}</option>
                //                     ))
                //                     : null
                //                 }
                //             </select>
                //             :
                //             <select className="form-control" name='facility' {...register("facility")}>
                //                 {facilityListForCustomer && facilityListForCustomer.length > 0 ?
                //                     facilityListForCustomer.map((item, index) => (
                //                         <option key={index} value={item.facility_id}>{item.facility_name}</option>
                //                     ))
                //                     : null
                //                 }
                //             </select>
                //         }
                //         {errors.facility && (
                //             <p className="errorMsg">{errors.facility.message}</p>
                //         )}
                //     </div>
                // </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <label
                  // className="required-label"
                  >
                    {roleType === "partner admin"
                      ? "Customer Name"
                      : roleType === "customer admin"
                      ? "Facility Name"
                      : ""}
                  </label>
                  <div className="form-group">
                    {roleType === "customer admin" && (
                      <>
                        <Controller
                          name="facility"
                          control={control}
                          rules={{ required: "Facility Name is required." }} // Add validation if needed
                          render={({ field }) => (
                            <Autocomplete
                              {...field}
                              options={facilityListForCustomer || []}
                              getOptionLabel={(option) => option.facility_name}
                              renderInput={(params) => (
                                <StyledTextFieldBootstrap
                                  {...params}
                                  placeholder="Select Facility"
                                />
                              )}
                              onChange={(_, value) => {
                                field.onChange(value ? value.facility_id : "");
                              }}
                              value={
                                facilityListForCustomer.find(
                                  (item) => item.facility_id === field.value
                                ) || null
                              }
                            />
                          )}
                        />
                        {errors.facility && (
                          <p className="errorMsg" style={{ color: "red" }}>
                            {errors.facility.message}
                          </p>
                        )}
                      </>
                    )}
                    {roleType === "partner admin" && (
                      <>
                        <Controller
                          name="customer"
                          control={control}
                          rules={{ required: "Customer is required." }} // Add validation if needed
                          render={({ field }) => (
                            <Autocomplete
                              {...field}
                              options={customerListForPartner || []}
                              getOptionLabel={(option) => option.client_name}
                              renderInput={(params) => (
                                <StyledTextFieldBootstrap
                                  {...params}
                                  placeholder="Select Customer"
                                />
                              )}
                              onChange={(_, value) => {
                                field.onChange(value ? value.client_name : "");
                              }}
                              value={
                                customerListForPartner.find(
                                  (item) => item.client_name === field.value
                                ) || null
                              }
                            />
                          )}
                        />
                        {errors.customer && (
                          <p className="errorMsg" style={{ color: "red" }}>
                            {errors.customer.message}
                          </p>
                        )}
                      </>
                    )}
                  </div>
                </div>
              )}
              {/* <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="role_type" className="required-label">
                  Role Type{" "}
                </label>
                <div className="form-group">
                  <FormControl fullWidth error={!!errors.user_type}>
                    <Controller
                      name="role_type"
                      control={control}
                      rules={{ required: "Role Type is required." }} // Add validation if needed
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          options={userType}
                          getOptionLabel={(option) => option} // Assuming userType is an array of strings
                          renderInput={(params) => (
                            <StyledTextFieldBootstrap
                              {...params}
                              placeholder="Select Role Type"
                            />
                          )}
                          onChange={(_, value) => {
                            field.onChange(value);
                            handleUserTypeChange(value); // Call the function with the selected value
                          }}
                          value={field.value || null} // Handle the case where the value might be null
                        />
                      )}
                    />
                    {errors.user_type && (
                      <p className="errorMsg" style={{ color: "red" }}>
                        {errors.user_type.message}
                      </p>
                    )}
                  </FormControl>
                </div>
              </div> */}
              <div
                className="col-12 d-flex"
                style={{ gap: "10px", padding: "0px" }}
              >
                <div className="col-6">
                  <button
                    type="submit"
                    className="btn btn__secondary btn__rounded btn__block mt-2"
                    style={{
                      backgroundColor: "#0E3F66",
                      color: "#FFFFFF",
                      borderRadius: "10px",
                      padding: "24px 140px",
                      gap: "10px",
                      "&:hover": {
                        backgroundColor: "#0E3F66",
                        color: "#FFFFFF",
                      },
                    }}
                  >
                    <span>Add User</span> <i className="icon-arrow-right"></i>
                  </button>
                </div>
                <div className="col-6">
                  <button
                    // variant="outlined"
                    // color="secondary"
                    // className="cancel-button"
                    onClick={() => setOpenRoleModal(true)}
                    className="btn btn__secondary btn__rounded btn__block mt-2"
                    style={{
                      backgroundColor: "#0E3F66",
                      color: "#FFFFFF",
                      borderRadius: "10px",
                      padding: "24px 140px",
                      gap: "10px",
                      "&:hover": {
                        backgroundColor: "#0E3F66",
                        color: "#FFFFFF",
                      },
                    }}
                  >
                    <span>Manage Roles</span>{" "}
                    <Icon name="manage_roles" size={26} />
                  </button>
                </div>
              </div>
              {/* <Tooltip title="Manage Roles">
              <ManageAccountsIcon
                onClick={() => setOpenRoleModal(true)}
                style={{
                  fontSize: "48px",
                  color: "#21cdc0",
                  cursor: "pointer",
                  display: "block",
                  margin: "40px auto",
                }}
              />
            </Tooltip> */}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default FacilityUsers;
